import { useRecoilState } from "recoil";
import { modalValorState } from "../../atom";

const useModalValorState = () => {
    return useRecoilState(modalValorState);
};

export default useModalValorState;